import React, { ComponentProps, MouseEventHandler, useCallback } from 'react'
import Caption from '../../../../LuxKit/Typography/Caption'
import TextLink from '../../../../LuxKit/TextLink'

interface Props {
  size: 'M' | 'L'
  onClick: MouseEventHandler<HTMLButtonElement | HTMLAnchorElement>
}

const SIZES_CAPTION_WEIGHTS: Record<Props['size'], ComponentProps<typeof Caption>['weight']> = {
  M: 'normal',
  L: 'bold',
}

function IncludesTaxesAndFeesDetails(props: Props) {
  const {
    size,
    onClick,
  } = props

  const handleClick = useCallback<MouseEventHandler<HTMLButtonElement | HTMLAnchorElement>>((event) => {
    event.preventDefault()
    event.stopPropagation()
    onClick(event)
  }, [onClick])

  return <Caption
    variant="medium"
    weight={SIZES_CAPTION_WEIGHTS[size]}
    colour="primary"
  >
    <TextLink onClick={handleClick}>
      Includes taxes and fees
    </TextLink>
  </Caption>
}

export default IncludesTaxesAndFeesDetails
